module.exports = __webpack_public_path__ + "img/area.a0757333.svg";